// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/6423ffb4a49f0446e94a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"e5807eac8b9c732238de","215":"a264f77cb977ab1485e4","216":"99a5dcf7aa4ba990f221"}[chunkId] + ".chunk.js";
};